import { useEffect, useState } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { LDEvaluationDetail } from 'launchdarkly-js-sdk-common';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { CenteredProgress } from '../../components';
import { decodeTokens, getAppConfig, getAuthInfo } from '../../utils';
let LDProviderTest: any;

interface propsChildren {
  children: JSX.Element;
}
const LaunchDarklyFeatureFlagInit = ({ children }: propsChildren) => {
  const { xbsEnvironment, launchDarklyEnv } = getAppConfig();
  const [isProviderReady, setConfigurationLoaded] = useState(false);
  const { authToken } = getAuthInfo();
  const decodedToken = decodeTokens(authToken);

  useEffect(() => {
    if (!isProviderReady && decodedToken) {
      (async () => {
        LDProviderTest = await asyncWithLDProvider({
          clientSideID: launchDarklyEnv[xbsEnvironment],
          user: {
            key: decodedToken.userId,
            name: '',
            email: ''
          },
          options: {
            inspectors: [
              {
                type: 'flag-used',
                name: 'dd-inspector',
                method: (key: string, detail: LDEvaluationDetail) => {
                  datadogRum.addFeatureFlagEvaluation(key, detail.value);
                }
              }
            ]
          }
        });
        setConfigurationLoaded(true);
      })();
    }
  }, [isProviderReady, xbsEnvironment, launchDarklyEnv, decodedToken]);
  return isProviderReady ? <LDProviderTest>{children}</LDProviderTest> : <CenteredProgress />;
};

export default LaunchDarklyFeatureFlagInit;
